<template>
    <div class="full-wdith" ref="addressBookComponentList">
        <div class="title-part" v-show="null != addressBookList && addressBookList.length > 0">
            <pageTitle :titleText="i18n.tkey('lang_invite_person_label')" />
        </div>

        <el-row :gutter="20" style="margin: 0">
            <el-col class="el-col-my" :span="contentSpan" v-for="(v, i) in addressBookList" :key="v.id">
                <userAddressBook :addressBook="v" :objIndex="i" @deleteSuccess="deleteCallback"/>
            </el-col>
        </el-row>
    </div>
</template>

<script setup>
    import pageTitle from "@/components/shopopee/common/pageTitle"
    import userAddressBook from "@/components/shopopee/card/userAddressBook"
    import {getCurrentInstance, inject, onMounted, ref} from "vue";

    const { proxy } = getCurrentInstance()

    const props = defineProps(["addressBookList"])
    const emits = defineEmits(["deleteSuccess"])

    const documentWidth = ref(375)

    const contentSpan = ref(2)

    const i18n = inject("i18n")

    function deleteCallback(index){
        emits("deleteSuccess", index)
    }

    onMounted(() => {
        documentWidth.value = proxy.$refs.addressBookComponentList.offsetWidth

        if (documentWidth.value > 1360){
            contentSpan.value = 6
        }else if (documentWidth.value > 768){
            contentSpan.value = 8
        }else if (documentWidth.value > 425){
            contentSpan.value = 12
        }else{
            contentSpan.value = 24
        }
    })
</script>

<style scoped>
    .full-wdith {
        width: 100%;
    }

    .title-part {
        margin-bottom: 20px;
    }

    .el-col-my {
        margin-bottom: 20px;
        border-radius: 4px;
    }
    .el-col-my:last-child {
        margin-bottom: 0;
    }

</style>